import gql from "graphql-tag";

// Get list of designation
const GET_DESIGNATION = gql`
	query Get_Designation($site: String!) {
		GetAllDesignation(site: $site) {
			docs {
				created_at
				id
				name
			}
		}
	}
`;

// New Designation
const NEW_DESIGNATION = gql`
	mutation NewDesignation($name: String!, $site: ID!) {
		CreateDesignation(name: $name, site: $site) {
			message
			doc {
				name
				id
				created_at
			}
		}
	}
`;
// Update Designation
const UPDATE_DESIGNATION = gql`
	mutation UpdateDesignation($name: String!, $id: ID!) {
		UpdateDesignation(name: $name, id: $id) {
			message
			doc {
				name
				id
				created_at
			}
		}
	}
`;

export { GET_DESIGNATION, NEW_DESIGNATION, UPDATE_DESIGNATION };
